export const jobDescLoader = {
  listJobDesc: 'listJobDesc',
  detailJobDesc: 'detailJobDesc',
  mainRespo: 'mainRespo',
  detailJobDescV2: 'detailJobDescV2',
  jobDescOrgStructure: 'jobDescOrgStructure',
  jobDescMainRespo: 'jobDescMainRespo',
  jobDescKPI: 'jobDescKPI',
  jobDescAuthority: 'jobDescAuthority',
  jobDescWorkRelation: 'jobDescWorkRelation',
};

export const initialStateJobDesc = {
  listJobDesc: true,
  detailJobDesc: true,
  mainRespo: true,
  detailJobDescV2: true,
  jobDescOrgStructure: true,
  jobDescMainRespo: true,
  jobDescKPI: true,
  jobDescAuthority: true,
  jobDescWorkRelation: true,
};
